import { useEffect, useState } from "react";
import rightArrow from "../../assets/images/icons/rightArrow.png";
import { Link, NavLink, useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import ReactPaginate from "react-paginate";
import qs from "qs";
import { Badge, Button, Col, Dropdown, Row } from "react-bootstrap";
import Filter from "../../components/Filter";
import Constants from "../Variables/Constants";
import axios from "axios";
import { toast } from "react-toastify";
import Y_Us_StripComponent from "../common/Y_us_strip";
import Product from "./Product";
import NoData from "../../components/NoData";
import Loader from "../../components/Loader";

const ProductsList = ({refetch}) => {
  const [params]=useSearchParams()
  const categoryId = params.get("categoryId")
  const collectionId = params.get("collectionId");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [productList, setProductList] = useState([]);
  const [flag, setFlag] = useState(false);
  const [categoryData, setCategoryData] = useState("");
  // const [collectionData, setCollectionData] = useState("");
  const [searchPayload, setSearchPayload] = useState({
    search: "",
    sortBy: "",
    startDate: "",
    endDate: "",
  });
  const [loader, setLoader] = useState(false);

  // Don't fetch products if categoryId or collectionId are missing
  if (!categoryId || !collectionId) {
    return (
      <div className="container-fluid px-2 px-sm-5">
        <div className="text-center py-5">
          <h4>No products available</h4>
          <p>Please select a category and collection to view products.</p>
        </div>
      </div>
    );
  }

  const getCategoryDetail = async () => {
    try {
      setLoader(true);
      const resp = await axios.get(
        `${Constants.getUrls.getAllCategory}/${categoryId}`
      );
      if (resp.data.status === "success") {
        setCategoryData(resp?.data?.data);
        setLoader(false);
      } else {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(resp.data.message);
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      try {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
        const { status, message } = error.response.data;
        if (status === 401 && message === "Unauthorized!") {
          localStorage.removeItem("token");
          window.location.href = "/";
        }
      } catch (error) {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
      }
    }
  };

  // const getCollectionDetail = async () => {
  //   try {
  //     setLoader(true);
  //     const resp = await axios.get(
  //       `${Constants.getUrls.getAllCollections}/${collectionId}`
  //     );
  //     if (resp.data.status === "success") {
  //       setCollectionData(resp.data.data);
  //       setLoader(false);
  //     } else {
  //       setLoader(false);
  //       toast.clearWaitingQueue();
  //       toast.dismiss();
  //       toast.error(resp.data.message);
  //     }
  //   } catch (error) {
  //     setLoader(false);
  //     try {
  //       toast.clearWaitingQueue();
  //       toast.dismiss();
  //       toast.error(error.message);
  //       const { status, message } = error.response.data;
  //       if (status === 401 && message === "Unauthorized!") {
  //         localStorage.removeItem("token");
  //         window.location.href = "/";
  //       }
  //     } catch (error) {
  //       toast.clearWaitingQueue();
  //       toast.dismiss();
  //       toast.error(error.message);
  //     }
  //   }
  // };

  const handlePageClick = (event) => {
    setCurrentPage(event.selected + 1); // Update the current page
  };

  const getAllProducts = ({ payload, url }) => {
    try {
      setLoader(true);
      axios
        .get(`${url}?${qs.stringify(payload)}`)
        .then((resp) => {
          if (resp.data.status === "success") {
            const data = resp.data.data.docs;
            if (data && Array.isArray(data) && data.length > 0) {
              setProductList(data);
            } else {
              setProductList([]);
            }
            setTotalPages(resp?.data?.data?.totalPages);
          }
          setLoader(false);
         
        })
        .catch((error) => {
          toast.clearWaitingQueue();
          toast.dismiss();
          toast.error(error.message);
          setLoader(false);
        });
    } catch (error) {
      setLoader(false);
      try {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
        const { status, message } = error.response.data;
        if (status === 401 && message === "Unauthorized!") {
          localStorage.removeItem("token");
          window.location.href = "/";
        }
      } catch (error) {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error.message);
      }
    }
  };

  useEffect(() => {
    if (categoryId && collectionId) {
      if (
        categoryData &&
        categoryData.title &&
        categoryData.title === "Tallis/Tefillin Bags"
      ) {
        const payload = {
          page: currentPage,
          limit: 20,
          category: categoryId,
          sub_category: collectionId,
          ...searchPayload,
        };
        const url = Constants.getUrls.getAllCustomizedProducts;
        getAllProducts({ payload, url });
      } else {
        const payload = {
          page: currentPage,
          limit: 20,
          category: categoryId,
          sub_category: collectionId,
          created_by: "admin",
          ...searchPayload,
        };
        const url = Constants.getUrls.getAllProducts;
        getAllProducts({ payload, url });
      }
    }
  }, [
    categoryId,
    collectionId,
    flag,
    searchPayload,
    currentPage,
    categoryData,
    refetch
  ]);

  useEffect(() => {
    if (categoryId && collectionId) {
      getCategoryDetail();
      // getCollectionDetail();
    }
  }, [categoryId, collectionId, flag]);

  return (
    <>
      <section className="mt-3">
        {loader && <Loader />}
        <div className="container-fluid px-2 px-sm-5">
          {/* <div className="d-flex justify-content-between flex-wrap gap-4 align-items-center">
            <nav className="my-5 font-poppins route-navigation">
              <ul className="d-flex gap-4 text-light-gray fs-20 fw-bold ">
                {" "}
                <li className="list-unstyled">
                  <Link to={"/"}>HOME </Link>
                </li>
                <li className="list-unstyled">
                  <img loading="lazy"  src={rightArrow} alt="" />
                </li>
                <NavLink to={`/category?catid=${categoryData?._id}`}>
                  <li className="list-unstyled whiteSpaceNo me-5">
                    {categoryData?.title}
                  </li>
                </NavLink>
                <li className="list-unstyled">
                  <img loading="lazy"  src={rightArrow} alt="" />
                </li>
                <NavLink
                  to={`/category/collection?catid=${categoryData?._id}&collectionId=${collectionData?._id}`}
                >
                  <li className="list-unstyled text-dark">
                    {collectionData?.title}
                  </li>
                </NavLink>
              </ul>
            </nav>

            {/* ✅ Filter Button Hidden (Commented Out) */}
            {/* <div>
            <Filter
              searchPayload={searchPayload}
              setSearchPayload={setSearchPayload}
            />
          </div> */}

            {/* ✅ Center Aligned Create Custom Product Button */}
            {/* <div className="mx-auto d-flex justify-content-center w-100">
              <button
                style={{ backgroundColor: "var(--primary-color)", color: "white" }}
                className="btn btn-lg"
                type="button"
                onClick={() => {
                  navigate(
                    `/customize?categoryId=${categoryId}&collectionId=${collectionId}`
                  );
                }}
              >
                Create Custom Product
              </button>
            </div>
          </div>  */}

          {productList.length === 0 && (
            <>
              <NoData
                image={"https://bepharco.com/no-products-found.png"}
                text={""}
              />
            </>
          )}

          {productList.length > 0 && (
            <>
              <Row className="g-4 mt-5">
                {productList.map((product, index) => (
                  <Col sm="6" md="6" lg="4" xl="3" key={product?._id} xxl="3">
                    <Product
                      product={product}
                      flag={flag}
                      setFlag={setFlag}
                      categoryId={categoryId}
                      collectionId={collectionId}
                    />
                  </Col>
                ))}
              </Row>

              <Row>
                <Col md={12} className="d-flex justify-content-center">
                  <ReactPaginate
                    previousLabel={"Previous"}
                    nextLabel={"Next"}
                    breakLabel={"..."}
                    pageCount={totalPages}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={3}
                    onPageChange={handlePageClick}
                    containerClassName={"pagination"}
                    pageClassName={"page-item"}
                    pageLinkClassName={"page-link"}
                    previousClassName={"page-item"}
                    previousLinkClassName={"page-link"}
                    nextClassName={"page-item"}
                    nextLinkClassName={"page-link"}
                    breakClassName={"page-item"}
                    breakLinkClassName={"page-link"}
                    activeClassName={"active"}
                  />
                </Col>
              </Row>
            </>
          )}
        </div>

        {/* <Y_Us_StripComponent /> */}
      </section>
    </>
  );


  // return (
  //   <>
  //     <section className="mt-3">
  //       {loader && <Loader />}
  //       <div className="container-fluid px-2 px-sm-5">
  //         <div className="d-flex justify-content-between flex-wrap gap-4 align-items-center">
  //           <nav className="my-5 font-poppins route-navigation">
  //             <ul className="d-flex gap-4 text-light-gray fs-20 fw-bold ">
  //               {" "}
  //               <li className="list-unstyled">
  //                 <Link to={"/"}>HOME </Link>
  //               </li>
  //               <li className="list-unstyled">
  //                 <img loading="lazy"  src={rightArrow} alt="" />
  //               </li>
  //               <NavLink to={`/category?catid=${categoryData?._id}`}>
  //                 <li className="list-unstyled whiteSpaceNo me-5">
  //                   {categoryData?.title}
  //                 </li>
  //               </NavLink>
  //               <li className="list-unstyled">
  //                 <img loading="lazy"  src={rightArrow} alt="" />
  //               </li>
  //               <NavLink
  //                 to={`/category/collection?catid=${categoryData?._id}&collectionId=${collectionData?._id}`}
  //               >
  //                 <li className="list-unstyled text-dark">
  //                   {collectionData?.title}
  //                 </li>
  //               </NavLink>
  //             </ul>
  //           </nav>
  //           <div className="mx-auto respon mx-sm-0 d-flex">
  //             <div>
  //               <Filter
  //                 searchPayload={searchPayload}
  //                 setSearchPayload={setSearchPayload}
  //               />
  //             </div>
  //             <div>
  //               <button style={{ backgroundColor: "var(--primary-color)", color: "white" }} className="btn btn-lg ms-4" type="button"
  //                 onClick={() => {
  //                   navigate(`/customize?categoryId=${categoryId}&collectionId=${collectionId}`)
  //                 }}
  //               >Create Custom Product</button>
  //             </div>
  //           </div>
  //         </div>

  //         {productList.length === 0 && (
  //           <>
  //             <NoData
  //               image={"https://bepharco.com/no-products-found.png"}
  //               text={""}
  //             />
  //           </>
  //         )}

  //         {productList.length > 0 && (
  //           <>
  //             <Row className="g-4 mt-5">
  //               {productList.map((product, index) => (
  //                 <Col sm="6" md="6" lg="4" xl="3" key={product?._id} xxl="3">
  //                   <Product
  //                     product={product}
  //                     flag={flag}
  //                     setFlag={setFlag}
  //                     categoryId={categoryId}
  //                     collectionId={collectionId}
  //                   />
  //                 </Col>
  //               ))}
  //             </Row>

  //             <Row>
  //               <Col md={12} className="d-flex justify-content-center">
  //                 <ReactPaginate
  //                   previousLabel={"Previous"}
  //                   nextLabel={"Next"}
  //                   breakLabel={"..."}
  //                   pageCount={totalPages}
  //                   marginPagesDisplayed={2}
  //                   pageRangeDisplayed={3}
  //                   onPageChange={handlePageClick}
  //                   containerClassName={"pagination"}
  //                   pageClassName={"page-item"}
  //                   pageLinkClassName={"page-link"}
  //                   previousClassName={"page-item"}
  //                   previousLinkClassName={"page-link"}
  //                   nextClassName={"page-item"}
  //                   nextLinkClassName={"page-link"}
  //                   breakClassName={"page-item"}
  //                   breakLinkClassName={"page-link"}
  //                   activeClassName={"active"}
  //                 />
  //               </Col>
  //             </Row>
  //           </>
  //         )}
  //       </div>

  //       <Y_Us_StripComponent />
  //     </section>
  //   </>
  // );
};

export default ProductsList;
